import { 
    CommisionProps 
} from "../Commission/types";
import { DateRangeEnum, RangeHandlerParams } from "../DatePicker/types";
import { RestApiState } from "../Rest/types";
import { AccumulatorChartDataList } from "../AccumulatorChart/types";
import { CustomDateRangeParams } from "../DatePicker/v2/types";
import { 
    JournalRequestParams, 
    JournalResponse 
} from "../Journal/types";

export enum InfoBlock {
    StatisticsInfo,
    LocationInfo,
    NotificationInfo,
    Journal,
    ConfigInfo,
    DocumentationInfo,
    ServiceInfo,
    OS,
}

// TODO refactor it in future
export type JournalParams = {
    isMessage: boolean;
    isWarning: boolean;
    isError: boolean;
    isBmsEvent: boolean;
    search?: string;
    ordering?: string;
    limit:number;
    offset:number;
    currentPage: number;
    timeout: NodeJS.Timeout | undefined;
    dateRange: RangeHandlerParams;
}

export interface PaginationProps {
    isOpen : boolean;
}

interface SectionViewProps {
    calendar: {
        isOpen: boolean;
        dateRange: DateRangeEnum
    };
    data: any | null;
    params: Record<string, any> | null;
    pagination?: {
        isOpen: boolean;
    };
}

interface CommissionSectionViewProps {
    data: CommisionProps | null | undefined;
}

export interface StatisticsSectionViewProps extends SectionViewProps {
    data: AccumulatorChartDataList | null;
    params: CustomDateRangeParams;
}

export interface JournalSectionViewProps extends SectionViewProps {
    data: JournalResponse | null | undefined;
    params: JournalRequestParams;
    pagination: {
        isOpen: boolean;
    };
    download: {
        requestState: RestApiState;
        btnDisabled : boolean;
        timeout: NodeJS.Timeout | null;
    }
}

export interface AcbViewProps {
    section: InfoBlock;
    statisticsSectionView: StatisticsSectionViewProps;
    commissionSectionView: CommissionSectionViewProps;
    journalSectionView: JournalSectionViewProps;
}